import { apiFetch } from "./http";
export type GuestSecurity = {
  enabled: boolean;
  configured: boolean;
  site_key: string;
};
export type TurnstileConfig = GuestSecurity & {
  verified: boolean;
  verification_error?: string | null;
  verification_hostname?: string | null;
  secret_saved: boolean;
  management_token_saved: boolean;
  management_token_environment: boolean;
  encrypted_at_rest: boolean;
  project_ref: string;
  revision: string;
  sync_error: string | null;
};
async function json<T>(response: Response): Promise<T> {
  const value = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(
      value.message || "The service is temporarily unavailable. Try again.",
    );
  return value as T;
}
export const fetchGuestSecurity = async () =>
  json<GuestSecurity>(
    await apiFetch("/auth/guest-security", {}, { authMode: "public" }),
  );
export const fetchTurnstileConfig = async () =>
  json<TurnstileConfig>(await apiFetch("/admin/turnstile/config"));
export const saveTurnstileConfig = async (body: Record<string, unknown>) =>
  json<TurnstileConfig>(
    await apiFetch("/admin/turnstile/config", {
      method: "PUT",
      body: JSON.stringify(body),
    }),
  );
export const testTurnstileConfig = async (revision: string, token: string) =>
  json<TurnstileConfig>(
    await apiFetch("/admin/turnstile/test", {
      method: "POST",
      body: JSON.stringify({ revision, token }),
    }),
  );
export const requestGuestRecovery = async (email: string, token: string) =>
  json<{ message: string }>(
    await apiFetch(
      "/auth/guest-recovery",
      {
        method: "POST",
        body: JSON.stringify({ email, captcha_token: token, confirmed: true }),
      },
      { authMode: "public" },
    ),
  );
